<template>
  <a-form-item :label="props.label" :name="props.name" :rules="isRules">
    <component
      :is="inputComponent"
      :placeholder="props.placeholder"
      :maxlength="props.maxLength"
      :disabled="props.disabled"
      :suffix="props.suffix"
      :value="props.modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      @keypress="onKeypress"
      :autocomplete="props.autocomplete"
    />
  </a-form-item>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { BaseInputProps, InputComponent } from "./type";
import { checkRude } from "@/utils/helper";

defineEmits(["update:modelValue"]);

const props = withDefaults(defineProps<BaseInputProps>(), {
  placeholder: "กรุณากรอก",
  type: "text",
  maxlength: 200,
  required: false,
  message: "",
  disabled: false,
});

const isRules = computed(() => {
  const rules = [
    {
      required: props.required,
      message: props.message,
    },
    {
      validator: checkRude,
    },
  ];
  if (!props.required || !props.rules) return rules;
  return [...rules, ...props.rules];
});

function onKeypress(event: KeyboardEvent) {
  switch (props.type) {
    case "number":
      const charCode = event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      return true;
    case "password":
      if (/[a-zA-Z0-9!@#$%^&*]/.test(event.key)) return true;
      event.preventDefault();
      break;
    default:
      return true;
  }
}

const inputComponent = computed<InputComponent>(() => {
  switch (props.type) {
    case "password":
      return "a-input-password";
    case "number":
    case "text":
    default:
      return "a-input";
  }
});
</script>
